import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import StandardLessonsPage from './pages/StandardLessonsPage';
import IntensiveLessonsPage from './pages/IntensiveLessonsPage';
import AdditionalLessonsPage from './pages/AdditionalLessonsPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import TipsPage from './pages/TipsPage';
import CancellationPage from './pages/CancellationPage';
import PrivacyCookiePage from './pages/PrivacyCookiePage';
import TermsPage from './pages/TermsPage';
import TotalDrivePage from './pages/TotalDrivePage';
import ScrollToTop from './components/ScrollToTop';
// Blog Pages
import BlogsPage from './pages/BlogsPage';
import Blog1PassFirstTime from './pages/blogs/Blog1PassFirstTime';
import Blog2AutomaticLessons from './pages/blogs/Blog2AutomaticLessons';
import Blog3IntensiveCourses from './pages/blogs/Blog3IntensiveCourses';
import Blog4NervousDrivers from './pages/blogs/Blog4NervousDrivers';
// Function to check if we need to redirect from www to non-www
const useWwwRedirect = () => {
  useEffect(() => {
    // Check if we're on www subdomain and redirect to non-www
    if (window.location.hostname.startsWith('www.')) {
      const newUrl = window.location.protocol + '//' + window.location.hostname.replace('www.', '') + window.location.pathname + window.location.search;
      window.location.replace(newUrl);
    }
  }, []);
};
export function App() {
  // Use the www redirect hook
  useWwwRedirect();
  return <HelmetProvider data-id="element-0">
      <Helmet data-id="element-1">
        <meta name="description" content="Expert automatic driving lessons in Northampton with DVSA-approved instructors. Intensive courses, refresher lessons, and support for nervous drivers. High pass rates." data-id="element-2" />
        <title data-id="element-3">
          Automatic Driving Lessons Northampton | Northampton Driving School
        </title>
        <meta name="keywords" content="automatic driving lessons Northampton, driving instructor Northampton, intensive driving courses, refresher driving lessons, DVSA approved instructors, nervous driver support" data-id="element-4" />
        <script type="application/ld+json" data-id="element-5">
          {`
            {
              "@context": "https://schema.org",
              "@type": "DrivingSchool",
              "name": "Northampton Driving School",
              "description": "Professional automatic driving lessons in Northampton with DVSA-approved instructors. Offering standard lessons, intensive courses, and specialized training for nervous drivers.",
              "url": "https://www.northamptondrivingschool.co.uk",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Northampton",
                "postalCode": "NN1 5SQ",
                "addressCountry": "UK"
              },
              "telephone": "07481 300 600",
              "email": "info@northamptondrivingschool.co.uk",
              "openingHours": "Mo-Th 09:15-19:00, Sa-Su 09:15-19:00",
              "serviceType": "Automatic Driving Lessons, Intensive Driving Courses, Refresher Lessons, Motorway Lessons",
              "areaServed": "Northampton"
            }
          `}
        </script>
        <link rel="canonical" href="https://northamptondrivingschool.co.uk" data-id="element-6" />
      </Helmet>
      <Router data-id="element-7">
        <ScrollToTop data-id="element-8" />
        <Layout data-id="element-9">
          <Routes data-id="element-10">
            <Route path="/" element={<HomePage data-id="element-12" />} data-id="element-11" />
            <Route path="/about" element={<AboutPage data-id="element-14" />} data-id="element-13" />
            <Route path="/standard-lessons" element={<StandardLessonsPage data-id="element-16" />} data-id="element-15" />
            <Route path="/intensive-lessons" element={<IntensiveLessonsPage data-id="element-18" />} data-id="element-17" />
            <Route path="/additional-lessons" element={<AdditionalLessonsPage data-id="element-20" />} data-id="element-19" />
            <Route path="/contact" element={<ContactPage data-id="element-22" />} data-id="element-21" />
            <Route path="/faq" element={<FAQPage data-id="element-24" />} data-id="element-23" />
            <Route path="/tips" element={<TipsPage data-id="element-26" />} data-id="element-25" />
            <Route path="/total-drive" element={<TotalDrivePage data-id="element-28" />} data-id="element-27" />
            <Route path="/cancellation" element={<CancellationPage data-id="element-30" />} data-id="element-29" />
            <Route path="/privacy" element={<PrivacyCookiePage data-id="element-32" />} data-id="element-31" />
            <Route path="/terms" element={<TermsPage data-id="element-34" />} data-id="element-33" />
            <Route path="/cookie-policy" element={<PrivacyCookiePage data-id="element-36" />} data-id="element-35" />
            {/* Blog Routes */}
            <Route path="/blogs" element={<BlogsPage data-id="element-38" />} data-id="element-37" />
            <Route path="/blogs/pass-first-time" element={<Blog1PassFirstTime data-id="element-40" />} data-id="element-39" />
            <Route path="/blogs/automatic-driving-lessons" element={<Blog2AutomaticLessons data-id="element-42" />} data-id="element-41" />
            <Route path="/blogs/intensive-driving-courses" element={<Blog3IntensiveCourses data-id="element-44" />} data-id="element-43" />
            <Route path="/blogs/nervous-drivers-tips" element={<Blog4NervousDrivers data-id="element-46" />} data-id="element-45" />
          </Routes>
        </Layout>
      </Router>
    </HelmetProvider>;
}